var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 269 536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.152 123.23H264.768C265.449 123.23 266 123.782 266 124.461V183.538C266 184.218 265.449 184.769 264.768 184.769H264.152V123.23Z",
    fill: "#121515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 160.153C3 159.473 3.55152 158.922 4.23185 158.922H4.84777V197.691H4.23185C3.55152 197.691 3 197.14 3 196.46V160.153Z",
    fill: "#121515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 111.539C3 110.86 3.55152 110.309 4.23185 110.309H4.84777V149.078H4.23185C3.55152 149.078 3 148.527 3 147.847V111.539Z",
    fill: "#121515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 74.0003C3 73.3206 3.55152 72.7695 4.23185 72.7695H4.84777V93.0772H4.23185C3.55152 93.0772 3 92.5262 3 91.8464V74.0003Z",
    fill: "#121515"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_958_275313)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84766 40.7692C4.84766 19.3576 22.2205 2 43.6509 2H225.349C246.779 2 264.152 19.3576 264.152 40.7692V491.231C264.152 512.642 246.779 530 225.349 530H43.6509C22.2205 530 4.84766 512.642 4.84766 491.231V40.7692Z",
    fill: "#3A4245"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92725 40.7704C7.92725 21.0581 23.9213 5.07812 43.6509 5.07812H225.349C245.078 5.07812 261.072 21.0581 261.072 40.7704V491.232C261.072 510.944 245.078 526.924 225.349 526.924H43.6509C23.9213 526.924 7.92725 510.944 7.92725 491.232V40.7704Z",
    fill: "#121515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.525 26.6157C165.246 26.6157 167.452 24.4115 167.452 21.6926C167.452 18.9737 165.246 16.7695 162.525 16.7695C159.803 16.7695 157.597 18.9737 157.597 21.6926C157.597 24.4115 159.803 26.6157 162.525 26.6157Z",
    fill: "#262C2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.524 24.771C164.225 24.771 165.604 23.3934 165.604 21.6941C165.604 19.9948 164.225 18.6172 162.524 18.6172C160.824 18.6172 159.445 19.9948 159.445 21.6941C159.445 23.3934 160.824 24.771 162.524 24.771Z",
    fill: "#121515"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.525 21.0784C162.865 21.0784 163.141 20.8029 163.141 20.463C163.141 20.1232 162.865 19.8477 162.525 19.8477C162.184 19.8477 161.909 20.1232 161.909 20.463C161.909 20.8029 162.184 21.0784 162.525 21.0784Z",
    fill: "#636F73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.794 21.6938C118.794 20.6742 119.62 19.8477 120.64 19.8477H148.36C149.38 19.8477 150.206 20.6742 150.206 21.6938C150.206 22.7134 149.38 23.54 148.36 23.54H120.64C119.62 23.54 118.794 22.7134 118.794 21.6938Z",
    fill: "#262C2D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_958_275313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 231,
    height: 500
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3022 34.6139H184.698C192.862 34.6139 199.48 28.0015 199.48 19.0754C199.564 17.4977 200.827 16.2358 202.402 16.1563L226.581 16.1523C239.507 16.1523 249.986 26.622 249.986 39.537V492.46C249.986 505.375 239.507 515.845 226.581 515.845H42.4193C29.493 515.845 19.0142 505.375 19.0142 492.46V39.537C19.0142 26.622 29.493 16.1523 42.4193 16.1523H66.5944C68.1735 16.2358 69.4365 17.4977 69.516 19.0714C69.52 28.0015 76.1382 34.6139 84.3022 34.6139Z",
    fill: "url(#pattern0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_958_275313)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0142 16.1523H249.986V515.845H19.0142V16.1523Z",
    fill: "url(#pattern1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_958_275313",
    x: 0.847656,
    y: 0,
    width: 267.305,
    height: 536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0823529 0 0 0 0 0.25098 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_958_275313"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0823529 0 0 0 0 0.25098 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_958_275313",
    result: "effect2_dropShadow_958_275313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_958_275313",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.293675f1d162e5e967ccc6f1bc629cd6.svg";
export { ForwardRef as ReactComponent };